import { Tables } from '@/lib/supabase/supabase_types_override';
import { supabase } from '@/lib/supabase/supabaseClient';
import { RemoveUserFromOrganizationProps } from '.';

export const removeUserFromOrganization = async ({
  userId,
  orgId,
}: RemoveUserFromOrganizationProps) =>
  await supabase
    .from('organisation_members')
    .delete()
    .eq('user_id', userId)
    .eq('organisation_id', orgId)
    .throwOnError();
